import "./ShopPage.scss";
import {filterCategoryResult} from "./components/Categories/filterCategoryResult";
import {useEffect, useState} from "react";
import {SERVER_NAME} from "../../../enum";
import {filterServerResult} from "./components/Categories/filterServerResult";
import {useProductsStore} from "../../../modules/shop/products/store";
import {useCategoriesStore} from "../../../modules/shop/categories/store";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Products from "./components/Products/Products";
import Categories from "./components/Categories/Categories";
import ServersTypeBlock from "./components/ServersTypeBlock/ServersTypeBlock";


const ShopPage = () => {
    //Получения всех категорий
    const categories = useCategoriesStore(state => state.categories)
    const fetchCategories = useCategoriesStore(state => state.fetchCategories)
    const [activeCategory, setActiveCategory] = useState({_id: 0, name: "Всі"})

    //Получение всех товаров
    const products = useProductsStore(state => state.products)
    const fetchProducts = useProductsStore(state => state.fetchProducts)

    useEffect(() => {
        fetchCategories()
        fetchProducts()
    }, [])

    //Фильтр по серверам
    const [activeServerHeader, setActiveServerHeader] = useState({id: 0, name: SERVER_NAME.ALL})
    const filterProductsServer = filterServerResult(activeServerHeader.name, products)

    // Тип из ServersTypeBlock
    const [type, setType] = useState<"lite" | "nasdara">("lite")

    //Фильтр по категориям
    const filterProductsCategory = filterCategoryResult(activeCategory, filterProductsServer, type)


    return (
        <>
            <div className="wrapper-content">
                <div className="content">
                    <Header />
                    <div className="containerContent">
                        <ServersTypeBlock setType={setType} />
                        <Categories
                            dataCategories={categories}
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory}
                            activeServerHeader={activeServerHeader}
                            setActiveServerHeader={setActiveServerHeader}
                        />
                    </div>
                </div>
                <Products dataProducts={filterProductsCategory} />
                <Footer />
            </div>
        </>
    );
};

export default ShopPage;